import { api } from '@/lib/api';

export interface Plan {
  id: string;
  name: string;
  slug: string;
  type: string;
  account_type?: string; // 'individual' | 'family'
  max_users_per_account?: number;
  description?: string;
  price_monthly: number;
  price_yearly: number;
  setup_fee: number;
  trial_days: number;
  features: Record<string, unknown>;
  is_popular?: boolean;
  plan_features?: {
    id: string;
    name: string;
    slug: string;
    is_enabled: boolean;
    is_highlighted: boolean;
  }[];
  require_card_on_signup?: boolean;
}

export interface CouponValidation {
  valid: boolean;
  reason?: string;
  data?: {
    code: string;
    /** valores conhecidos: 'percentage' | 'fixed' */
    discount_type: string;
    discount_value: number;
    validity_type: string;
    validity_months?: number | null;
    limited_to_plan: boolean;
    plan_id?: string | null;
    minimum_amount?: number | null;
    first_time_only?: boolean;
    max_uses?: number | null;
    max_uses_per_subscriber?: number | null;
    valid_from?: string | null;
    valid_until?: string | null;
  };
}

class PlanService {
  async listPublicPlans(): Promise<Plan[]> {
    const res = await api.get('/public/plans');
    return res.data.data as Plan[];
  }

  async validateCoupon(
    code: string,
    email?: string,
    planId?: string,
    billingCycle?: 'monthly' | 'yearly'
  ): Promise<CouponValidation> {
    const res = await api.get('/public/coupons/validate', {
      params: {
        code,
        email,
        plan_id: planId,
        billing_cycle: billingCycle,
      },
    });
    return res.data as CouponValidation;
  }
}

export default new PlanService();
